import React, { useState } from "react"

import { useTranslation } from "react-i18next"

import {Modal} from "components/modals/Modal"

import { AdminPlayerBonus2 } from "services/bonus/type"

import { getDisplayName } from "../../helpers/bonus2.helpers"

interface Props {
  playerBonus: AdminPlayerBonus2
  username?: string
  onConfirm: (depositAmount: number | null) => void
  onClose: () => void
  loading?: boolean
}

export const ActivateBonusModal = ({ playerBonus, username, onConfirm, onClose, loading = false }: Props) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const [depositAmount, setDepositAmount] = useState("")

  const handleConfirm = () => {
    const deposit = depositAmount ? parseFloat(depositAmount) : null
    onConfirm(deposit)
  }

  return (
    <Modal open={true} handler={onClose}>
      <div className="bg-[#1A1A2E] rounded-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-bold text-white mb-4">{t("bonus2.players.activateBonus")}</h3>

        <div className="space-y-4">
          <div className="bg-[#0C0C1A] rounded-lg p-3">
            <div className="text-gray-400 text-sm">{t("bonus2.players.bonus")}</div>
            <div className="text-white font-semibold">{getDisplayName(playerBonus.bonus?.name, t("bonus2.shared.unknownBonus") as string)}</div>
            <div className="text-gray-500 text-xs">{playerBonus.bonus?.type}</div>
          </div>

          <div className="bg-[#0C0C1A] rounded-lg p-3">
            <div className="text-gray-400 text-sm">{t("bonus2.players.player")}</div>
            <div className="text-white font-semibold">{username || playerBonus.user_id}</div>
          </div>

          <div className="bg-[#0C0C1A] rounded-lg p-3">
            <div className="text-gray-400 text-sm">{t("bonus2.players.coin")}</div>
            <div className="text-white font-semibold">{playerBonus.coin}</div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              {t("bonus2.players.depositAmountOptional")}
              <span className="text-gray-500 ml-2 text-xs">{t("bonus2.players.forPercentageBasedBonuses")}</span>
            </label>
            <input
              type="number"
              value={depositAmount}
              onChange={(e) => setDepositAmount(e.target.value)}
              placeholder={t("bonus2.players.enterDepositAmount")}
              className="w-full bg-[#0C0C1A] text-white border border-gray-600 rounded px-3 py-2"
              min="0"
              step="0.01"
            />
          </div>

          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="flex-1 px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 disabled:opacity-50"
            >
              {t("bonus2.players.close")}
            </button>
            <button
              onClick={handleConfirm}
              disabled={loading}
              className="flex-1 px-4 py-2 bg-emerald-600 text-white rounded hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? t("bonus2.players.activating") : t("bonus2.players.activateBonus")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
